import { colors } from '../foundation';

type Props = {
  color?: (typeof colors.red)[50] | typeof colors.primary.white;
};

const Minus = ({ color = colors.red[50] }: Props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Navigation &#38; Actions/minus">
        <path id="Vector" d="M12.9036 8H3.07031" stroke={color} strokeMiterlimit="10" strokeLinecap="round" />
      </g>
    </svg>
  );
};
export default Minus;
